export type PointerLatch = {
  claim(pointerId: number): boolean
  owns(pointerId: number): boolean
  release(pointerId: number): void
  reset(): void
  isHeld(): boolean
}

/** First pointer owns the stage until it is released. Extra pointers are ignored. */
export function createPointerLatch(): PointerLatch {
  let owner: number | null = null
  return {
    claim(pointerId: number): boolean {
      if (owner === null) {
        owner = pointerId
        return true
      }
      return owner === pointerId
    },
    owns(pointerId: number): boolean {
      return owner === pointerId
    },
    release(pointerId: number): void {
      if (owner === pointerId) owner = null
    },
    reset(): void {
      owner = null
    },
    isHeld(): boolean {
      return owner !== null
    },
  }
}

export function isFirstPointer(event: PointerEvent, latch: PointerLatch): boolean {
  if (event.isPrimary === false) return false
  return latch.claim(event.pointerId)
}
